import {useEffect} from "react";
import {DevCycleUser, useDevCycleClient} from "@devcycle/react-client-sdk";

/**
 * DevCycle user id configured in the dashboard to target RXD (unauthenticated) traffic.
 * RXD routes sit outside RequireAuth; {@link useDevCycleIdentifier} never runs, and with
 * `deferInitialization` the client needs an explicit identify before variables resolve.
 */
export const RXD_DEVCYCLE_USER_ID = "system_rxd";

/**
 * Identify DevCycle as the RXD system user while the RXD shell is mounted.
 * Call from {@link RxdLayout} so `use-app-2` and other flags can be evaluated for iframe / public RXD.
 */
export const useDevCycleRxdSystemIdentifier = (): void => {
	const devCycleClient = useDevCycleClient();

	useEffect(() => {
		const devCycleUser: DevCycleUser = {
			user_id: RXD_DEVCYCLE_USER_ID,
			isAnonymous: false,
			email: "",
			customData: {},
		};

		devCycleClient.identifyUser(devCycleUser, error => {
			if (error) {
				console.error("devCycleClient.identifyUser (RXD system_rxd)", error);
			}
		});
	}, [devCycleClient]);
};
